import domNodeMap from '../domNodeMap';

// ({ name: String, initOnLoad: Boolean, initialDom: DOMDocument }) -> DataSource
function dataSource({ name, initOnLoad, initialDom }) {
    initOnLoad = !!initOnLoad;
    let dom = initialDom;

    const { getNode, purgeNodes, assignIds } = domNodeMap(name);

    const reassignIds = () => {
        purgeNodes();
        assignIds(dom);
    };

    const setDom = (domNode) => {
        dom = domNode;
    };

    const getDom = () => dom;

    // interface
    return {
        name,
        initOnLoad,
        setDom,
        getDom,
        reassignIds,
        getNodeById: getNode,
        assignIds,
    };
}

export default dataSource;